/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionPlanTaskDependencyDto
 */
export interface ExecutionPlanTaskDependencyDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    predecessorId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    successorId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    dependencyType?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    lagDays?: number;
    /**
     * 
     * @type {Date}
     * @memberof ExecutionPlanTaskDependencyDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the ExecutionPlanTaskDependencyDto interface.
 */
export function instanceOfExecutionPlanTaskDependencyDto(value: object): value is ExecutionPlanTaskDependencyDto {
    return true;
}

export function ExecutionPlanTaskDependencyDtoFromJSON(json: any): ExecutionPlanTaskDependencyDto {
    return ExecutionPlanTaskDependencyDtoFromJSONTyped(json, false);
}

export function ExecutionPlanTaskDependencyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionPlanTaskDependencyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'predecessorId': json['predecessorId'] == null ? undefined : json['predecessorId'],
        'successorId': json['successorId'] == null ? undefined : json['successorId'],
        'dependencyType': json['dependencyType'] == null ? undefined : json['dependencyType'],
        'lagDays': json['lagDays'] == null ? undefined : json['lagDays'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function ExecutionPlanTaskDependencyDtoToJSON(json: any): ExecutionPlanTaskDependencyDto {
    return ExecutionPlanTaskDependencyDtoToJSONTyped(json, false);
}

export function ExecutionPlanTaskDependencyDtoToJSONTyped(value?: ExecutionPlanTaskDependencyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'planId': value['planId'],
        'predecessorId': value['predecessorId'],
        'successorId': value['successorId'],
        'dependencyType': value['dependencyType'],
        'lagDays': value['lagDays'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

